/**
 * Reakcja na dane, których kontrakt nie przewiduje — klucz spoza rejestru,
 * kwota bez waluty. W rozwoju przerywamy, żeby rozjazd wyszedł przy pierwszym
 * uruchomieniu; na produkcji logujemy i pozwalamy domalować ekran, bo jedna
 * nieznana pozycja nie może zabrać operatorowi całej zakładki.
 */
export const reportStatsContractBreach = (message: string): void => {
  if (import.meta.env.DEV) throw new Error(message);
  console.error(message);
};
